import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClipboardCheck, faPaste, faDownload, faClipboardList, faFileSignature, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { initialAllOptionPromises } from "../../../../helper/utils";
import { useManagePostRequest } from "../../../../hooks/useManagePostRequest/useManagePostRequest";
import { useManageGetRequest } from "../../../../hooks/useManageGetRequest/useManageGetRequest";
import { useGetOptionsSelect } from "../../../../hooks/useGetOptionsSelect/useGetOptionsSelect";
import { usePropsSelect } from "../../../../hooks/useProps/usePropsSelect";
import GenericUploadFileV2 from "../../../../components/GenericUploadFile/GenericUploadFileV2";
import ActionGenericModal from "../../../../components/modal/ActionGenericModal";
import InputMultiSelect from "../../../../components/modalComponents/InputMultiSelect";
import GenericTooltip from "../../../../components/GenericTooltip/GenericTooltip";
import GenericTooltipWithButton from "../../../../components/GenericTooltipWithButton/GenericTooltipWithButton";
import { cargarDocumentoEmpleadoAPI, validarDocumentoEmpleadoAPI, eliminarDocumentoEmpleadoAPI, descargarDocumentoEmpleadoFromPlantillaAPI, updateListaDocumentosEmpleadoNuevosIngresosAPI, getListaDocumentosEmpleadoNuevoIngresoGestionAPI, getListaDocumentosAPI, reemplazarDocumentoEmpleadoNuevosIngresosAPI, cambiarPasoObligatorioDocumentoEmpleadoAPI, getNuevosIngresosPasosObligatoriosOptionsByIdNuevosIngresosEmpleado, firmarDocumentoEmpleadoAPI, subirFirmaDocumentosIngresoAPI, eliminarFirmaDocumentosIngresoAPI, eliminarDocumentosEmpleadoAPI } from "../../../../consumers/backendApisUrls";
import { FILE_FORMATS } from "../../../../constants/hardCodedConstants";
import InputUploadFile from "../../../../components/modalComponents/InputUploadFile";
import AgregarFirma from "../modales/AgregarFirma";

const ListaDocumentos = ({ listDocuments, idNuevosIngresosEmpleado, manageSearchListaDocumentos, inputDisabled, isColaborador, signature, puedeGestionarFirma, urlInstructivoFirma }) => {
  const SECTION_NAME = "EditarListasDocumentos";
  const NO_OBLIGATORIO_STEP = 0;
  const KEYS_INIT = { ListaDocumentos: "IdsListasDocumentos", PasosObligatorios: "IdsPasosObligatorios", FirmaFileViewModel: "FirmaFileViewModel" };
  const MESSAGE_DNI = "En esta lista de documentos solo subir el  DNI del colaborador por ambas caras, en el caso de DNI'S conyuge y/o hijos se solicitará en una siguiente actividad.";
  const UrlInstructivoCargaDoc = "https://drive.google.com/drive/folders/1JQkYxhhZDXGs0_heOVnVG9lZ3-kPQqGN?usp=sharing";
  const [modalEnable, setModalEnable] = useState({ isEnable: false });
  const [allDropdowns, setAllDropdowns] = useState([]);
  const [formValues, setFormValues] = useState({});
  const [firmaColaborador, setFirmaColaborador] = useState({
    idNuevosIngresosEmpleado: idNuevosIngresosEmpleado
  });
  const [fileSigned, setFileSigned] = useState(0);
  const [isSigningDocuments, setIsSigningDocuments] = useState(false);
  const pendingSignDocIdsRef = useRef([]);

  const [executePost] = useManagePostRequest();
  const [executeGet] = useManageGetRequest();
  const [getOptions] = useGetOptionsSelect();
  const [commonPropsSelect] = usePropsSelect(allDropdowns, formValues, setFormValues, SECTION_NAME);

  console.log("urlInstructivoFirma", urlInstructivoFirma)

  const initPromises = () => {
    return [
      getOptions(getListaDocumentosAPI()),
      getOptions(getNuevosIngresosPasosObligatoriosOptionsByIdNuevosIngresosEmpleado(idNuevosIngresosEmpleado)),
    ]
  }

  const init = async () => {
    try {
      if (!isColaborador) initialAllOptionPromises(initPromises, Object.values(KEYS_INIT), (res) => setAllDropdowns(res));
      manageSearch();
    } catch (error) {
      console.error(error);
    }
  }

  const manageSearch = async () => {
    const api = getListaDocumentosEmpleadoNuevoIngresoGestionAPI(idNuevosIngresosEmpleado);
    return await executeGet(api, (res) => setFormValues({ [KEYS_INIT.ListaDocumentos]: res.data }));
  }

  const updateListaDocumentos = () => {
    const api = updateListaDocumentosEmpleadoNuevosIngresosAPI();
    let payload = { IdNuevosIngresosEmpleado: idNuevosIngresosEmpleado, ...formValues };
    executePost(api, payload, () => { manageSearch(); manageSearchListaDocumentos() });
  }

  const handleUploadFile = async (res, api, IdNuevosIngresosEmpleadoDocumento) => {
    let payload = { IdNuevosIngresosEmpleadoDocumento, File: { ...res } };
    await executePost(api(), payload, () => manageSearchListaDocumentos());
  }

  const handleDownloadPlantilla = async (idPlantilla) => {
    const api = descargarDocumentoEmpleadoFromPlantillaAPI(idPlantilla);
    await executePost(api, {}, successDownloadNombrePlantilla)
  }

  const handleSignFile = async (idNuevosIngresosEmpleadoDocumento) => {
    if (fileSigned !== 0) return;
    if (signature === null) {
      setModalEnable({
        isEnable: true,
        component: AgregarFirma,
        data: {
          KEYS_INIT,
          firmaColaborador,
          handleUploadSignature,
          SECTION_NAME,
          onSubmit: firmarDocumentoEmpleadoAPI(idNuevosIngresosEmpleadoDocumento),
          urlInstructivoFirma
        },
      });
      return;
    }
    else {
      setFileSigned(idNuevosIngresosEmpleadoDocumento);
      const api = firmarDocumentoEmpleadoAPI(idNuevosIngresosEmpleadoDocumento);
      await executePost(api, {}, () => manageSearchListaDocumentos());
      setFileSigned(0);
    }
  }

  const successDownloadNombrePlantilla = (res) => {
    let { FilePath } = res?.data;
    window.open(FilePath);
  }

  const handleActionsObligatorio = async (api, IdNuevosIngresosEmpleadoDocumento) => {
    await executePost(api(IdNuevosIngresosEmpleadoDocumento), {}, () => manageSearchListaDocumentos());
  }

  const handlePasoObligatorio = async (IdNuevosIngresosEmpleadoDocumento, PasoObligatorio) => {
    const api = cambiarPasoObligatorioDocumentoEmpleadoAPI();
    const payload = { IdNuevosIngresosEmpleadoDocumento, PasoObligatorio };
    await executePost(api, payload, () => manageSearchListaDocumentos());
  }

  const chooseAPIForDocumentSiganture = (res) => {
    return Object.keys(res).length === 0
      ? eliminarFirmaDocumentosIngresoAPI()
      : subirFirmaDocumentosIngresoAPI();
  };

  const handleUploadSignature = async (res) => {
    const api = chooseAPIForDocumentSiganture(res);
    const isDelete = Object.keys(res).length === 0;
    const updatedFirmaColaborador = {
      ...firmaColaborador,
      [KEYS_INIT.FirmaFileViewModel]: res,
    };
    setFirmaColaborador(updatedFirmaColaborador);

    await executePost(api, updatedFirmaColaborador, () => {
      manageSearchListaDocumentos();
      if (!isDelete) {
        setIsSigningDocuments(true);
      }
    });

    if (isDelete && listDocuments) {
      const signedDocIds = listDocuments
        .filter(doc => doc.PuedeFirmar && doc.PuedeDescargar)
        .map(doc => doc.IdNuevosIngresosEmpleadoDocumento);

      if (signedDocIds.length > 0) {
        await executePost(
          eliminarDocumentosEmpleadoAPI(),
          { Ids: signedDocIds },
          () => manageSearchListaDocumentos()
        );
      }
    }
  }

  useEffect(() => {
    init();
  }, [])

  useEffect(() => {
    setFirmaColaborador({ ...firmaColaborador, FirmaFileViewModel: signature });
  }, [signature])

  useEffect(() => {
    if (!isSigningDocuments) return;

    pendingSignDocIdsRef.current = (listDocuments ?? [])
      .filter(doc => doc.PuedeFirmar && !doc.PuedeDescargar)
      .map(doc => doc.IdNuevosIngresosEmpleadoDocumento);

    let cancelled = false;
    let safetyTimer = setTimeout(() => {
      cancelled = true;
      setIsSigningDocuments(false);
    }, 120000);

    const doPoll = async () => {
      if (cancelled) return;
      await manageSearchListaDocumentos();
      if (!cancelled) setTimeout(doPoll, 2500);
    };

    doPoll();

    return () => {
      cancelled = true;
      clearTimeout(safetyTimer);
    };
  }, [isSigningDocuments]);

  useEffect(() => {
    if (!isSigningDocuments || !listDocuments) return;

    const pendingIds = pendingSignDocIdsRef.current;
    if (pendingIds.length === 0) return;

    const allSigned = pendingIds.every(id => {
      const doc = listDocuments.find(d => d.IdNuevosIngresosEmpleadoDocumento === id);
      return doc?.PuedeDescargar === true;
    });

    if (allSigned) setIsSigningDocuments(false);
  }, [listDocuments, isSigningDocuments]);

  return (
    <div className="container-fluid body-content pt-4 pb-3">
      {modalEnable.isEnable &&
        <div className="modal-contactanos modal-response-ficha-background">
          <modalEnable.component toggleModal={() => setModalEnable({ isEnable: false })} refreshPage={manageSearchListaDocumentos} {...modalEnable.data} />
        </div>
      }
      <div className="row justify-content-center">
        {!isColaborador &&
          <>
            <div className="col-sm-6">
              <InputMultiSelect label="Listas de Documentos" {...commonPropsSelect("IdsListasDocumentos", [], true)} isDisabled={inputDisabled} />
            </div>
            <div className="col-sm-3 pt-1 d-flex justify-content-center align-items-start">
              <button type="button" className="btn btn-primary generic-button-ficha-modal" onClick={updateListaDocumentos} disabled={inputDisabled}>Guardar</button>
            </div>
          </>
        }
      </div>
      {isColaborador &&
        <div className="col-sm-12">
          <p className="required mb-0">{MESSAGE_DNI}</p>
        </div>
      }
      <div className="d-flex justify-content-center">
        <p className="ficha-form-input-validation-message" id={`ficha-edit-${SECTION_NAME}-Files-validation-message`} />
      </div>
      {isSigningDocuments &&
        <div className="text-center py-3">
          <FontAwesomeIcon icon={faSpinner} spin size="2x" className="blue-standard-color" />
          <p className="mt-2">Firmando documentos, por favor espere...</p>
        </div>
      }
      <table className="table table-hover table-bordered">
        <thead className="listar-thead">
          <tr>
            <th colSpan={isColaborador ? 3 : 4} className="table-header-bold">Documento Asignado</th>
            <th colSpan={isColaborador ? 2 : 1} className="table-header-bold">Documento Firmado <GenericTooltipWithButton
              id="tooltipSubirDocumentos"
              tooltipText="¿Necesitas ayuda?"
              buttonText="Revisar la guía"
              buttonFunction={() => window.open(UrlInstructivoCargaDoc, "_blank")}
              customSize="20px"
            />
            </th>
            {!isColaborador &&
              <th colSpan={2} className="table-header-bold">Acciones</th>
            }
          </tr>
          <tr className="">
            <th className="col-6 text-center">Nombre</th>
            <th className="col-1 text-center">
              <label>
                Descargar formato
                <GenericTooltip id="tooltipDescargarFormato" text="Descarga el documento en la flecha azul y revisa la información" />
              </label>
            </th>
            <th className="col-2 text-center pb-0">
              <label>
                Firmar
                <GenericTooltipWithButton
                  id="tooltipFirmar"
                  tooltipText="Puedes firmar el documento cargando la imagen de tu firma."
                  buttonText="Revisar la guía"
                  buttonFunction={() => window.open(urlInstructivoFirma, "_blank")}
                />
              </label>
              {puedeGestionarFirma && (
                signature ? (
                  <div className="mt-2">
                    <InputUploadFile
                      label=""
                      direction="column"
                      name={KEYS_INIT.FirmaFileViewModel}
                      uploadFile={firmaColaborador[KEYS_INIT.FirmaFileViewModel]}
                      setUploadFile={handleUploadSignature}
                      sectionName={SECTION_NAME}
                      showToastSuccess={false}
                      validExtensions={FILE_FORMATS.ALLOWED_IMAGE_FORMATS}
                    />
                  </div>
                ) : (
                  <div className="mt-2">
                    <button
                      type="button"
                      style={{
                        width: "auto"
                      }}
                      className="btn btn-primary mb-0 custom-button-adjuntar"
                      onClick={() => {
                        setModalEnable({
                          isEnable: true,
                          component: AgregarFirma,
                          data: {
                            KEYS_INIT,
                            firmaColaborador,
                            handleUploadSignature,
                            SECTION_NAME,
                            urlInstructivoFirma,
                          },
                        });
                      }}>
                      Subir Firma
                    </button>
                  </div>
                )
              )}
            </th>

            {!isColaborador && <th className="col-1 text-center">Reemplazar</th>}
            <th className="col-1 text-center">
              <label>
                Subir Documento
                <GenericTooltip id="tooltipSubirDescargar" text="Carga el documento completado y firmado" />
              </label>
            </th>
            {isColaborador && <th className="col-1 text-center">Es Obligatorio</th>}
            {!isColaborador &&
              <>
                <th className="col-1 text-center">Validar</th>
                <th className="col-2 text-center">Obligatorio</th>
              </>
            }
          </tr>
        </thead>
        <tbody className="listar-tbody">
          {listDocuments?.map((list, i) => (
            <tr key={`${list.IdNuevosIngresosEmpleadoDocumento}`}>
              <td>{list?.NombreDocumento}</td>
              <td className="text-center">
                <DownloadFile list={list} handleDownloadPlantilla={handleDownloadPlantilla} />
              </td>
              <td className="text-center">
                {!list?.EsReemplazado &&
                  <SignFile list={list}
                    handleSignFile={handleSignFile}
                    fileSigned={fileSigned} />
                }
              </td>

              {!isColaborador &&
                <td className="text-center">
                  <UploadReplacementFile list={list} handleUploadFile={handleUploadFile} />
                </td>
              }
              <td className="text-center upload-file-p-small">
                <UploadDownloadFile list={list} setModalEnable={setModalEnable} handleUploadFile={handleUploadFile} />
              </td>
              {isColaborador &&
                <td className="text-center">
                  <input type="checkbox" checked={list?.EsObligatorio} disabled />
                </td>
              }
              {!isColaborador &&
                <>
                  <td className="text-center">
                    <ValidateFile list={list} handleActionsObligatorio={handleActionsObligatorio} />
                  </td>
                  <td className="text-center">
                    <Select
                      isDisabled={list.EsValidado}
                      options={allDropdowns.find(o => o.key === KEYS_INIT.PasosObligatorios)?.value.filter(o => o.value === NO_OBLIGATORIO_STEP || o.value >= list?.PasoActual)}
                      value={allDropdowns.find(o => o.key === KEYS_INIT.PasosObligatorios)?.value?.find(o => o.value === list?.PasoObligatorio)}
                      onChange={(e) => handlePasoObligatorio(list.IdNuevosIngresosEmpleadoDocumento, e.value)}
                      placeholder="Seleccionar"
                    />
                  </td>
                </>
              }
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ListaDocumentos;

const DownloadFile = ({ list, handleDownloadPlantilla }) => (
  list?.FormatoUrl ?
    <label className="mx-4 mb-0 hand-pointer blue-standard-color"
      onClick={() => window.open(list.FormatoUrl)}>
      <FontAwesomeIcon title="Descargar archivo" size="lg" icon={faDownload} />
    </label> :
    list?.IdPlantilla ?
      <label className="mx-4 mb-0 hand-pointer blue-standard-color"
        onClick={() => {
          handleDownloadPlantilla(
            list.IdNuevosIngresosEmpleadoDocumento
          )
        }}>
        <FontAwesomeIcon title="Descargar archivo" size="lg" icon={faDownload} />
      </label> :
      <div>-</div>
)

const SignFile = ({ list, handleSignFile, fileSigned }) =>
  list?.PuedeFirmar ? (
    <label
      className={`mx-4 mb-0 hand-pointer ${list?.PuedeDescargar ? "green-innova" : "blue-standard-color"}`}
      onClick={() => {
        handleSignFile(list?.IdNuevosIngresosEmpleadoDocumento);
      }}>
      {list?.IdNuevosIngresosEmpleadoDocumento !== fileSigned ? (
        <FontAwesomeIcon
          title="Firmar archivo"
          size="lg"
          icon={faFileSignature}
        />
      ) : (
        <FontAwesomeIcon
          title="Cargando..."
          size="lg"
          spin={true}
          icon={faSpinner}
        />
      )}
    </label>
  ) : (
    <div>-</div>
  );

const UploadReplacementFile = ({ list, handleUploadFile }) => (
  (list.PuedeReemplazar && !(list.Formato === null && list.IdPlantilla === null)) && !list.FileUrl &&
  <GenericUploadFileV2
    id="SubirReemplazoArchivoListaDocumentos"
    extensionesValidas={["pdf", "png", "jpg"]}
    uploadFileToS3={(res) => handleUploadFile(res, reemplazarDocumentoEmpleadoNuevosIngresosAPI, list.IdNuevosIngresosEmpleadoDocumento)}
    textButton="Subir archivo"
    resetInitialFile={false}
    showToastSuccess={false}
    isIcon
    icon={faPaste}
  />
)

const UploadDownloadFile = ({ list, setModalEnable, handleUploadFile }) => (
  <div className="d-flex justify-content-center" style={{ gap: "15px" }}>
    {list.PuedeSubir &&
      <GenericUploadFileV2
        id="SubitArchivoListaDocumentos"
        extensionesValidas={["pdf", "png", "jpg"]}
        uploadFileToS3={(res) => handleUploadFile(res, cargarDocumentoEmpleadoAPI, list.IdNuevosIngresosEmpleadoDocumento)}
        textButton="Subir archivo"
        resetInitialFile={false}
        showToastSuccess={false}
        isIcon
        iconColor="required"
      />
    }
    {list.PuedeDescargar &&
      <label className="hand-pointer green-innova mb-0" onClick={() => window.open(list.FileUrl)}>
        <FontAwesomeIcon title="Descargar archivo" size="lg" icon={faDownload} />
      </label>
    }
    {list.PuedeEliminar &&
      <FontAwesomeIcon
        icon="trash"
        size="lg"
        title="Eliminar"
        className="blue-standard-color hand-pointer"
        onClick={() => setModalEnable({ isEnable: true, component: ActionGenericModal, data: { api: eliminarDocumentoEmpleadoAPI, id: list.IdNuevosIngresosEmpleadoDocumento, name: list.File?.OriginalFileName } })}
      />
    }
  </div>
)

const ValidateFile = ({ list, handleActionsObligatorio }) => (
  list.PuedeValidar &&
  <FontAwesomeIcon
    icon={list.EsValidado ? faClipboardCheck : faClipboardList}
    size="lg"
    title={`${list.EsValidado ? "Invalidar" : "Validar"}`}
    className={`hand-pointer ${list.EsValidado ? "green-innova" : "blue-standard-color"}`}
    onClick={() => handleActionsObligatorio(validarDocumentoEmpleadoAPI, list.IdNuevosIngresosEmpleadoDocumento)}
  />
)